import React, { useState, useEffect } from "react";
import "./report.css";
import IncidentDetail from "./IncidentDetail";
import logo from "../../assets/logo.png";
import { useLocation } from "react-router-dom";


export default function ReportPage() {
  const location = useLocation();
  const employeeCode = location.state?.employeeCode;
  const [incidents, setIncidents] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);
  const [selectedIncident, setSelectedIncident] = useState(null);

  useEffect(() => {
    fetchIncidents();
  }, []);

  const fetchIncidents = async () => {
    try {
      const response = await fetch(
        "https://mondelezbc.vsmglobaltechnologies.com/api/incident"
      );

      if (!response.ok) {
        throw new Error("Failed to fetch incidents");
      }

      const json = await response.json();

      if (!json.data) {
        throw new Error("No incidents data found");
      }

      setIncidents(json.data);
      setLoading(false);
    } catch (err) {
      console.error("Incidents fetch error:", err);
      setError("Failed to load incidents");
      setLoading(false);
    }
  };

  // Show IncidentDetail component if an incident is selected
  if (selectedIncident) {
    return (
      <IncidentDetail
        incident={selectedIncident}
        onBack={() => setSelectedIncident(null)}
      />
    );
  }

  if (loading) {
    return (
      <div className="safety-page">
        <div className="header">
          <img src={logo} alt="Mondelez Logo" className="logo" />
          <h2>SNACKING MADE RIGHT</h2>
          <p>Digital Tool Of Safety System</p>
        </div>
        <p className="loading-text">Loading incidents...</p>
      </div>
    );
  }

  if (error) {
    return (
      <div className="safety-page">
        <div className="header">
          <img src={logo} alt="Mondelez Logo" className="logo" />
          <h2>SNACKING MADE RIGHT</h2>
          <p>Digital Tool Of Safety System</p>
        </div>
        <div className="error-display">
          <span className="error-icon">⚠️</span>
          <h2 className="error-title">Error</h2>
          <p className="error-message">{error}</p>
        </div>
      </div>
    );
  }

  return (
    <div className="safety-page">
      <a className="home-icon" href="/">
        <svg
          fill="#fff"
          version="1.1"
          id="Capa_1"
          xmlns="http://www.w3.org/2000/svg"
          width="35px"
          height="35px"
          viewBox="0 0 495.398 495.398"
        >
          <g>
            <g>
              <g>
                <path
                  d="M487.083,225.514l-75.08-75.08V63.704c0-15.682-12.708-28.391-28.413-28.391c-15.669,0-28.377,12.709-28.377,28.391
				v29.941L299.31,37.74c-27.639-27.624-75.694-27.575-103.27,0.05L8.312,225.514c-11.082,11.104-11.082,29.071,0,40.158
				c11.087,11.101,29.089,11.101,40.172,0l187.71-187.729c6.115-6.083,16.893-6.083,22.976-0.018l187.742,187.747
				c5.567,5.551,12.825,8.312,20.081,8.312c7.271,0,14.541-2.764,20.091-8.312C498.17,254.586,498.17,236.619,487.083,225.514z"
                />
                <path
                  d="M257.561,131.836c-5.454-5.451-14.285-5.451-19.723,0L72.712,296.913c-2.607,2.606-4.085,6.164-4.085,9.877v120.401
				c0,28.253,22.908,51.16,51.16,51.16h81.754v-126.61h92.299v126.61h81.755c28.251,0,51.159-22.907,51.159-51.159V306.79
				c0-3.713-1.465-7.271-4.085-9.877L257.561,131.836z"
                />
              </g>
            </g>
          </g>
        </svg>
      </a>
      <div className="header">
        <img src={logo} alt="Mondelez Logo" className="logo" />
        <h2>SNACKING MADE RIGHT</h2>
        <p>Digital Tool Of Safety System</p>
        <p className="telugu">ఒక సంఘటనను నివేదించండి</p>
        <h3>Report an incident</h3>
      </div>

      <div className="icon-grid">
        {incidents.map((incident) => (
          <div
            key={incident._id}
            className="icon-card"
            onClick={() => setSelectedIncident({ ...incident, employeeCode })}
          >
            <img
              src={incident.filePathUrl}
              alt={incident.incidentNameEnglish}
            />
            <p className="incident-name-english">
              {incident.incidentNameEnglish}
            </p>
            <p className="incident-name-telugu">
              {incident.incidentNameTelugu}
            </p>
          </div>
        ))}
      </div>
    </div>
  );
}
